import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../App.css";
import unavailableImage from "../images/503-page.png";
import Header from "./Includes/Header";
import Spacer from "./UI/Spacer";
import { useNavigate } from "react-router-dom";
import Footer from "./Includes/Footer";

const ServiceUnavailablePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <Col md={1} />
          <Col md={5}>
            <div className="mt-5 mx-5">
              <Spacer height="150px" />
              <div className="error-header">
                <span className="error-text">503</span>
                <span className="error-line"></span>
              </div>
              <h2 className="Error-Head">{t('errors.503_title')}</h2>
              <p className="py-4">{t('errors.503_desc')}</p>
              <Button
                className="btn btn-primary py-2 mt-3 rounded-5"
                onClick={() => navigate("/")}
              >
                {t('common.back_home')}
              </Button>
            </div>
          </Col>
          <Col md={6} className="text-center bg-sky">
            <div className="mt-5 mx-5">
              <Spacer height="150px" />
              <img
                src={unavailableImage}
                alt="Service Unavailable"
                className="img-fluid"
              />
              <Spacer height="120px" />
            </div>
          </Col>
        </Row>
      </Container>
      <Footer full />
    </>
  );
};

export default ServiceUnavailablePage;
